import { useTranslation } from "react-i18next";
import { useInjuredTypeOptions, useResponsiveBp, useYesNoAnswer } from "src/utils";

export const useInjured = () => {
  const { t } = useTranslation();
  const { isMobile } = useResponsiveBp();
  const { injuredTypeOptions } = useInjuredTypeOptions();
  const {yesNoOptions} = useYesNoAnswer();

  return { isMobile, injuredTypeOptions, yesNoOptions, t };
};
